<!--设备 充电桩页-->
<template>
    <div>
        <top-bar
            :height="'48vh'"
            title="充电桩"
            addTitle="添加单个桩"
            multipleAddTitle="添加多个桩"
            @refresh="refresh"
            @add="add"
            @multipleAdd="multipleAdd"
            @chooseSite="choose"
            :selectSite="selectSite"
            @search="search"
            :isSite="isSite"
            :loading="loading"
            :showSelectPile="false"
            :isShowRefresh="true"
        />
        <v-container fluid class="mt-n6">
            <v-row>
                <v-col cols="12" md="12">
                    <v-img
                        v-if="no_data"
                        width="100%"
                        height="100%"
                        src="@/assets/no_data.svg"
                    ></v-img>
                    <v-data-table
                        v-else
                        style="cursor:pointer"
                        :headers="headers"
                        :items="dataTable"
                        :items-per-page="10"
                        :loading="loading"
                        :footer-props="footerProps"
                        loading-text="数据加载中..."
                        no-data-text="暂无数据"
                        disable-sort
                        :dark="theme.tableDark"
                    >
                        <template v-slot:item.name="{ item }">
                            <el-link
                                type="primary"
                                icon="el-icon-view el-icon--right"
                                class="ml-3"
                                @click="editor(item)"
                            >
                                {{ item.name }}
                            </el-link>
                        </template>
                        <!-- <template v-slot:item.cec_id="{ item }">
                            <el-tag v-if="!item.cec_id" size="mini">
                                否
                            </el-tag>
                            <div v-else>
                                <el-tag size="mini">{{ cecText(item.cec_id) }}</el-tag>
                            </div>
                        </template> -->
                        <template v-slot:item.type="{ item }">
                            {{ model(item.type) }}
                        </template>
                        <template v-slot:item.gun_status="{ item }">
                            <el-button
                                size="mini"
                                type="primary"
                                circle
                                icon="iconfont icon-chongdianqiang1"
                                @click="toGun(item.station_id, item.id)"
                            ></el-button>
                        </template>
                        <template v-slot:item.download="{ item }">
                            <el-button
                                type="primary"
                                size="small"
                                circle
                                icon="el-icon-download"
                                @click="clickDownload(item)"
                            ></el-button>
                        </template>
                        <template v-slot:item.delete="{ item }">
                            <el-button type="text" @click="deletePile(item)">
                                <v-icon class="ml-3" color="red">
                                    mdi-delete
                                </v-icon>
                            </el-button>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        <!-- 下载二维码 -->
        <div v-show="false">
            <img ref="bg" :src="ewmPath" alt="二维码背景" width="45%" height="45%" />
            <div v-for="(item, index) in connectorData" :key="index">
                <vue-qr
                    :id_name="'qcode_' + index"
                    :qid="item.qid"
                    :text="item.url"
                    :margin="5"
                    colorDark="black"
                    colorLight="#fff"
                    :size="200"
                    :callback="getQcodeUrl"
                ></vue-qr>
            </div>
        </div>
        <!-- 添加单个桩 -->
        <v-dialog scrollable v-model="isOpneDialog" width="35rem" overlay-color="#262626">
            <equipment-form
                @cancel="cancel"
                @refresh="refresh"
                :isAdd="isAdd"
                :isEdit="isEdit"
                ref="addEquipment"
                :passData="equipmentData"
                :station_id="selectSite"
            />
        </v-dialog>
        <!-- 添加多个桩 -->
        <v-dialog scrollable v-model="isOpneMultipleDialog" width="35rem" overlay-color="#262626">
            <more-equipment-form
                ref="moreForm"
                @cancel="cancel"
                @refresh="refresh"
                :station_id="selectSite"
            />
        </v-dialog>
        <!-- <el-button type="primary" @click="getAllGun()">获取所有充电枪数据</el-button> -->
        <el-button type="primary" @click="getAllGun()">获取所有充电桩数据</el-button>
        <download-excel
            class = "export-excel-wrapper"
            :data = "json_data"
            :fields = "json_fields"
            title="所有充电桩数据"
            name = "所有充电桩数据.xls">
            <el-button type="primary">导出所有桩数据为EXCEL</el-button>
        </download-excel>
    </div>
</template>

<script>
String.prototype.byteLength = function() {
    var length = 0;
    Array.from(this).map(function(char) {
        if (char.charCodeAt(0) > 255) {
            //字符编码大于255，说明是双字节字符
            length += 2;
        } else {
            length++;
        }
    });

    return length;
};
String.prototype.pxWidth = function(font) {
    var canvas =
            String.prototype.pxWidth.canvas ||
            (String.prototype.pxWidth.canvas = document.createElement("canvas")),
        context = canvas.getContext("2d");
    font && (context.font = font);
    var metrics = context.measureText(this);
    return metrics.width;
};
import util from "@/util";
import SelectSite from "@/components/SelectSite";
import Public from "@/public";
import EquipmentForm from "@/components/Form/EquipmentForm";
import MoreEquipmentForm from "@/components/Form/MoreEquipmentForm";
import TopBar from "@/components/TopBar";
import store from "@/store";
import vueQr from "vue-qr";
import { mapState, Store } from "vuex";
export default {
    name: "ChargingPile",
    data() {
        return {
            json_fields: {
                "站点ID": "station_id",
                "站点名称": "station_name",
                "桩名称": "name", 
                "桩ID": "cec_equipment_id",
                "桩类型": "type_text",
                "桩总功率": "power",
                "充电枪数量": "nums"
            },
            json_data:[],    //导出表格数据
            json_meta: [
              [
                {
                  " key ": " charset ",
                  " value ": " utf- 8 "
                }
              ]
            ],
            siteName: null, //站点名称
            loading: false, //刷新动画
            no_data: false,
            siteId: null, //站点ID
            isOpneDialog: false, //打开添加单个桩弹框
            isOpneMultipleDialog: false, //打开添加多个桩弹框
            isAdd: false,
            isEdit: false,
            isSite: true,
            selectSite: null, //选中的站点
            headers: [
                { text: "充电桩名称", value: "name" },
                { text: "设备编码", value: "cec_equipment_id" },
                { text: "额定功率", value: "power" },
                { text: "设备模式", value: "type" },
                // { text: "互联互通", value: "cec_id" },
                { text: "充电枪", value: "gun_status" },
                { text: "二维码", value: "download" },
                { text: "", value: "delete" },
            ],
            dataTable: [],
            footerProps: {
                itemsPerPageText: "每页显示数目",
                itemsPerPageOptions: [5, 10, 15],
                showCurrentPage: true,
                showFirstLastPage: true,
            },
            equipmentData: null,
            typeText: [
                {
                    id: 1,
                    value: "直流设备",
                },
                {
                    id: 2,
                    value: "交流设备",
                },
                {
                    id: 3,
                    value: "交直流一体设备",
                },
                {
                    id: 4,
                    value: "无线",
                },
                {
                    id: 5,
                    value: "其他",
                },
            ],
            connectorData: [], //需要下载二维码图片的充电枪信息
            allGun: []
        };
    },
    watch: {
        selectSite: {
            handler(val) {
                this.isSite = false;
                this.$nextTick(() => {
                    this.isSite = true;
                });
                this.getData(this.selectSite);
            },
        },
        siteList: {
            handler(val) {
                let data = JSON.parse(JSON.stringify(val));
                this.selectSite = data[0].children[0].id;
            },
        },
        dataTable: {
            handler(val) {
                if (val.length == 0) {
                    this.no_data = true;
                } else {
                    this.no_data = false;
                }
            },
        },
        isOpneDialog: {
            handler(val) {
                if (val == true) {
                } else {
                    this.isEdit = false;
                    this.isAdd = false;
                }
            },
        },
    },
    async mounted() {
        if (this.toGunSiteId) {
            this.selectSite = this.toGunSiteId;
        } else if (this.siteList[0]) {
            this.selectSite = this.siteList[0].children[0].id;
        }
        this.refresh();
    },
    components: {
        SelectSite,
        EquipmentForm,
        MoreEquipmentForm,
        TopBar,
        vueQr,
    },
    computed: {
        ...mapState([
            "siteList",
            "equipmentInfo",
            "toGunSiteId",
            "theme",
            "contactInfo",
            "connectorInfo",
            "ewmPath",
        ]),
    },
    methods: {
        //获取所有充电桩数据
        async get() {
            const loading = this.$loading({
                lock: true,
                text: '正在获取所有充电桩数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let site = this.JsonData(this.siteList)
            console.log(site)
            let allsite = []
            for(let i = 0;i<site.length;i++) {
                if(site[i].label === "直连站点") {
                    for(let j = 0;j<site[i].children.length;j++) {
                        if(site[i].children[j].status == 50) {
                            allsite.push({
                                station_id: site[i].children[j].id,
                                station_name: site[i].children[j].value
                            })
                        }
                    }
                }
            }
            let promiseArr = [];
            let postDataArr = [];
            for (let i = 0; i < allsite.length; i++) {
                let postData = {
                    station_id: allsite[i].station_id,
                    from: 0,
                    limit: 10000,
                };
                await store.dispatch("getEquipment", postData);
                let promise = new Promise((resolve, reject) => {
                    let data = this.JsonData(this.equipmentInfo)
                    // for(let j = 0;j<data.length;j++) {
                    //     data[j].station_id = allsite[i].station_id
                    // }
                    resolve(data);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    console.log(result)
                    let info = []
                    for(let i = 0;i<result.length;i++) {
                        for(let j =0;j<result[i].value.length;j++) {
                            for(let n = 0; n<allsite.length;n++) {
                                if(allsite[n].station_id == result[i].value[j].station_id) {
                                    result[i].value[j].station_name = allsite[n].station_name
                                }
                            }
                            info.push(result[i].value[j])
                        }
                    }
                    for(let a = 0;a<info.length;a++) {
                        info[a].nums = 0;
                         if(info[a].type == 1) {
                             info[a].type_text = "直流设备"
                         }else if(info[a].type == 2) {
                             info[a].type_text = "交流设备"
                         }else if(info[a].type == 3) {
                             info[a].type_text = "交直流一体设备"
                         }else if(info[a].type == 4) {
                             info[a].type_text = "无线设备"
                         }
                         else if(info[a].type == 5) {
                             info[a].type_text = "其他"
                         }
                    }
                    console.log(this.allGun)
                    for(let i = 0;i<info.length;i++) {
                        for(let j = 0;j<this.allGun.length;j++) {
                            if(info[i].id == this.allGun[j].equipment_id && info[i].station_id == this.allGun[j].station_id) {
                                info[i].nums += 1
                            }
                        }
                    }
                    console.log(info)
                    this.json_data = info;
                    loading.close();
                    util.ShowTip("总共获取到"+info.length+"条数据", 1);
                })
                .catch(error => {
                    loading.close();
                    util.ShowTip(error, 2);
                });
        },
        //获取所有充电枪数据
        async getAllGun() {
            const loading = this.$loading({
                lock: true,
                text: '正在获取所有充电枪数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let site = this.JsonData(this.siteList)
            let allsite = []
            for(let i = 0;i<site.length;i++) {
                if(site[i].label === "直连站点") {
                    for(let j = 0;j<site[i].children.length;j++) {
                        if(site[i].children[j].status == 50) {
                            allsite.push({
                                station_id: site[i].children[j].id,
                                station_name: site[i].children[j].value
                            })
                        }
                    }
                }
            }
            console.log(allsite)
            let promiseArr = [];
            for (let i = 0; i < allsite.length; i++) {
                let postData = {
                    station_id: allsite[i].station_id,
                };
                await store.dispatch("getConnector", postData);
                let promise = new Promise((resolve, reject) => {
                    let data = this.JsonData(this.connectorInfo)
                    for(let j = 0;j<data.length;j++) {
                        data[j].station_id = allsite[i].station_id
                    }
                    resolve(data);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    console.log(result)
                    let info = []
                    for(let i = 0;i<result.length;i++) {
                        for(let j =0;j<result[i].value.length;j++) {
                            info.push(result[i].value[j])
                        }
                    }
                    for(let a = 0;a<info.length;a++) {
                        if(info[a].type == 1) {
                            info[a].type_text = "家用插座"
                        }else if(info[a].type == 2) {
                            info[a].type_text = "交流接口插座"
                        }else if(info[a].type == 3) {
                            info[a].type_text = "交流接口插头"
                        }else if(info[a].type == 4) {
                            info[a].type_text = "直流接口枪头"
                        }
                        else if(info[a].type == 5) {
                            info[a].type_text = "无线充电座"
                        }
                        else if(info[a].type == 6) {
                            info[a].type_text = "其他"
                        }
                    }
                    // console.log(info)
                    this.allGun = info;
                    loading.close();
                    // util.ShowTip("总共获取到"+info.length+"条数据", 1);
                    this.get();
                })
                .catch(error => {
                    loading.close();
                    util.ShowTip(error, 2);
                });
        },
        /*搜索*/
        async search(reg) {
            this.loading = true;
            let postData = {
                station_id: this.selectSite,
                from: 0,
                limit: 10000,
            };
            await store.dispatch("getEquipment", postData);
            let dataArr = [];
            for (let i = 0; i < this.equipmentInfo.length; i++) {
                if (
                    reg.test(this.equipmentInfo[i].cec_equipment_id) ||
                    reg.test(this.equipmentInfo[i].cec_id) ||
                    reg.test(this.equipmentInfo[i].id) ||
                    reg.test(this.equipmentInfo[i].name)
                ) {
                    dataArr.push(this.equipmentInfo[i]);
                }
            }
            this.dataTable = this.JsonData(dataArr.reverse());
            this.loading = false;
            if (dataArr.length == 0) {
                util.ShowTip("未查找到相关数据", 2);
                await this.refresh();
                return;
            }
            util.ShowTip("查询到" + dataArr.length + "条数据", 1);
        },
        /*列表刷新*/
        refresh() {
            if (this.selectSite) {
                this.getData(this.selectSite);
            }
        },
        /*添加设备*/
        add() {
            this.isOpneDialog = true;
            this.isAdd = true;
        },
        /*获取到二维码图片*/
        getQcodeUrl(url, name) {
            let index = Number(name);
            for (let i = 0; i < this.connectorData.length; i++) {
                if (index == Number(this.connectorData[i].qid)) {
                    this.connectorData[i].imgSrc = url;
                }
            }
        },
        /*下载二维码*/
        clickDownload(item) {
            this.connectorData = [];
            let connectorInfos = JSON.parse(JSON.stringify(this.connectorInfo));
            for (let i = 0; i < connectorInfos.length; i++) {
                if (item.id == connectorInfos[i].equipment_id) {
                    this.connectorData.push({
                        url: "http://ecar.meisenpay.com/evc/" + connectorInfos[i].connector_id, // 二维码的地址
                        // url:
                        //     "https://www.meisencharge.com/internet-mutual/meisenqrcode?qrcode=" +
                        //     connectorInfos[i].connector_id,
                        fileName: connectorInfos[i].name, // 设置每一个二维码的文件名
                        imgSrc: "", // 生成的二维码放图片的字段
                        connName: item.name + "-" + connectorInfos[i].name, //每把枪的名字
                        qid: connectorInfos[i].id.toString(),
                        connector_id: connectorInfos[i].connector_id,
                    });
                }
            }
            if (this.connectorData.length == 0) {
                util.ShowTip("充电枪不存在", 3);
                return;
            }
            setTimeout(() => {
                this.downloadImg();
            }, 500);
        },
        downloadImg() {
            let img2 = this.$refs.bg;
            let img2Height = img2.naturalHeight + 60;  //背景图的高度
            let img2Width = img2.naturalWidth + 60;    //背景图的宽度度
            for (let j = 0; j < this.connectorData.length; j++) {
                let connector_id = this.connectorData[j].connector_id;
                let connectorName = this.connectorData[j].connName;
                let name = (connectorName + "-" + connector_id).toString();
				
				const canvas = document.createElement("canvas");
				let context = canvas.getContext("2d");
                let img = new Image();
                img.src = this.connectorData[j].imgSrc;
                let imgHeight = img.naturalHeight; //二维码图片的高度
                let imgWidth = img.naturalWidth;   //二维码图片的宽度
				
                canvas.height = 2008  //画布的高度
                canvas.width = 1475;  //画布的高度
                let ewmHeight = 500; //二维码图片高度
                let ewmwidth = 500; //二维码图片宽度
                let left_x = 860; //二维码距离左边
                let top_y = 520; //二维码距离顶部边
                context.drawImage(img2, 0, 0, img2Width, img2Height); // 加入背景图
                context.drawImage(img, 0, 0, imgWidth, imgHeight, left_x, top_y, ewmwidth, ewmHeight);  //添加二维码图片
                context.fillStyle = "black"; // 设置文字的填充颜色
                context.font = "normal 45px normal"; // 设置文字的填充样式
                let ll = left_x + ewmwidth / 2 - connector_id.pxWidth(context.font) / 2;  //设置编号距离左边的位置
                context.fillText(connector_id, ll, top_y + ewmHeight + 60);    //在图片上添加编号
                let a = this.siteName.match(/美森宝-(\S*)/) ? this.siteName.match(/美森宝-(\S*)/)[1] : this.siteName;
                let ll2 = left_x + ewmHeight / 2  - a.pxWidth(context.font) / 2;
                context.fillText(a, ll2, top_y + ewmHeight + 115);
                // 构造url
                var url = canvas.toDataURL("image/png");
                let ah = document.createElement("a");
                ah.href = url;
                ah.download = name;
                ah.click();
            }
            this.connectorData = [];
        },
        /*添加多个设备*/
        multipleAdd() {
            if (this.$refs.moreForm) {
                this.$refs.moreForm.form["station_id"] = this.selectSite;
            }
            this.isOpneMultipleDialog = true;
        },
        /*点击数据表中的设备id*/
        editor(item) {
            this.equipmentData = item;
            this.isOpneDialog = true;
            this.isEdit = true;
            if (this.$refs.addEquipment) {
                this.$refs.addEquipment.equipmentData = item;
            }
        },
        cancel() {
            this.isOpneDialog = false;
            this.isOpneMultipleDialog = false;
        },
        /*下拉框选择站点*/
        async choose(site) {
            console.log(site)
            this.siteName = site.siteName;
            this.selectSite = site.siteId;
        },
        /*获取站点设备信息*/
        async getData(id) {
            if (!this.isOpneDialog) {
                this.loading = true;
            }
            let postData = {
                station_id: id,
            };
            await store.dispatch("getEquipment", postData);
            await store.dispatch("getConnector", postData);
            this.dataTable = this.JsonData(this.equipmentInfo);
            this.dataTable.sort(Public.createComprisonFunction("cec_equipment_id"));
            this.loading = false;
        },
        /*前往充电枪页面*/
        toGun(station_id, pile_id) {
            this.$router.push({
                name: "ChargingGun",
            });
            store.commit("SET_ISJUMP", true);
            store.commit("SET_PILE_ID", pile_id);
            store.commit("SET_GUN_SITE_ID", station_id);
        },
        /*删除设备*/
        deletePile(item) {
            let params = {
                postData: { id: item.id },
                callback: () => {
                    this.refresh();
                },
            };
            const h = this.$createElement;
            this.$confirm("是否删除充电桩：" + item.name, "提示", {
                title: "提示",
                message: h("p", null, [
                    h("span", null, "是否删除充电桩：  "),
                    h("i", { style: "color: red" }, item.name),
                ]),
                showCancelButton: true,
                center: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    store.dispatch("deletePile", params);
                })
                .catch(() => {});
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
        /*模式*/
        model(type) {
            let text = "";
            this.typeText.forEach((val, index) => {
                if (val.id == type) {
                    text = val.value;
                }
            });
            return text;
        },
        cecText(cec_id) {
            if (this.contactInfo.length === 0) {
                store.dispatch("getConnact", {});
            }
            let text = "";
            if (!cec_id) {
                return;
            }
            for (let i = 0; i < this.contactInfo.length; i++) {
                if (cec_id === this.contactInfo[i].id) {
                    text = this.contactInfo[i].name;
                }
            }
            return text;
        },
    },
    beforeRouteLeave(to, from, next) {
        if (to.path != "/devices/gun") {
            store.commit("SET_ISJUMP", false);
            store.commit("SET_PILE_ID", null);
            store.commit("SET_GUN_SITE_ID", null);
        }
        next();
    },
};
</script>

<style scoped></style>
